import useCarSeriesDelete from 'api/carSeries/useCarSeriesDelete/useCarSeriesDelete';
import useCarSeriesList from 'api/carSeries/useCarSeriesList/useCarSeriesList';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import CarSeriesEditModal from 'components/shared/Modals/carSeries/CarSeriesEditModal/CarSeriesEditModal';
import CarSeriesInsertModal from 'components/shared/Modals/carSeries/CarSeriesInsertModal/CarSeriesInsertModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useCarSeriesTableColumns from 'hooks/carSeries/useCarSeriesTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const CarSeries = () => {
  const { guid } = useParams();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getCarSeriesList, loading, carSeriesList, pageRef] =
    useCarSeriesList(guid);

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenCarSeries, setEditChosenCarSeries] = useState({});

  const [deleteRequest] = useCarSeriesDelete();

  const tableRef = useRef(null);

  const navigate = useNavigate();
  const { can } = usePermissions();

  const seriesPermissions =
    permissions.general.categories.globalSettings.coddingSettings.carFactory
      .brands.models.series;

  const canCreate = can(seriesPermissions.create);
  const canEdit = can(seriesPermissions.edit);
  const canDelete = can(seriesPermissions.delete);
  const canDetail = can(seriesPermissions.manufacturingDate.view);

  useEffect(() => {
    getCarSeriesList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getCarSeriesList({ page, count: pageSize });
  }, [pageSize]);

  const goToInfoPage = useCallback(
    row => () => navigate(`/carProductionTime/${row.id}`),
    [],
  );

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenCarSeries(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const [columnsData] = useCarSeriesTableColumns(
    goToInfoPage,
    deleteItem,
    editItem,
    tableRef,
    {
      canDetail,
      canEdit,
      canDelete,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(id, getCarSeriesList, setIsDeleteModalOpen, setDeleteLoading);
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getCarSeriesList({
      page: pageNumber,
      count: pageSize,
      term: lastSearch,
    });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getCarSeriesList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(carSeriesList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={carSeriesList[page]}
          rows={carSeriesList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت سری خودرو' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canCreate ? (
        <CarSeriesInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getCarSeriesList={getCarSeriesList}
          modelGuid={guid}
        />
      ) : null}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canEdit ? (
        <CarSeriesEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenCarSeries={editChosenCarSeries}
          getCarSeriesList={getCarSeriesList}
        />
      ) : null}
    </>
  );
};

export default CarSeries;
